(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('ApExceptionsModalController', ["$q", "$scope", "$modalInstance", "$rootScope", "$timeout", "options", "apAvananExceptionsDao", "tablePaginationHelper", "defaultListConverter", "modals", "regexUtility", "feature", "troubleshooting", function ($q, $scope, $modalInstance, $rootScope, $timeout, options, apAvananExceptionsDao, tablePaginationHelper, defaultListConverter, modals, regexUtility, feature, troubleshooting) {
        $scope.loading = true;
        $scope.error = '';
        $scope.params = [];
        $scope.params1 = [];
        $scope.loaded = false;
        $scope.notAllowed = '';
        var keyword = 'phishing';
        if (options.type === 'whitelist') {
            keyword = 'clean';
        }
        function simpleTooltipConverter(text) {
            return '#' + JSON.stringify({
                display: 'text',
                text: text,
                tooltip: {
                    content: { text: text },
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    style: {
                        classes: 'qtip-standard ap-avanan-blacklist-tip',
                        def: false
                    }
                }
            });
        }
        var locationChangeUnsubscribe = $rootScope.$on('$locationChangeStart', function () {
            $modalInstance.dismiss();
        });
        $scope.$on('$destroy', function () {
            locationChangeUnsubscribe();
        });
        $scope.ok = function () {
            if ($scope.loading) {
                return;
            }
            return modals.confirm({
                title: 'Caution',
                message: 'Marking emails as ' + keyword + ' triggers your policies.<br/>' + 'In case any active policy for ' + keyword + ' is running - it will affect the ' + ($scope.withLinksToDomainsWarning ? 'scope of the rule' : 'following ' + $scope.totalEmails + ' emails') + '.<br/>' + '<strong>Are you sure you want to continue?</strong>',
                okText: 'Yes',
                cancelText: 'No'
            }).then(function () {
                $scope.loading = true;
                if (options.loadFn && _(options.loadFn).isFunction()) {
                    options.loadFn();
                }
                var createAPI;
                if (options.type === 'whitelist') {
                    var exceptionData;
                    if (feature.enableAPWhitelistReason) {
                        exceptionData = makeFilters([$scope.params1]);
                    } else {
                        exceptionData = makeFilters();
                    }
                    createAPI = apAvananExceptionsDao.add(exceptionData);
                } else {
                    createAPI = apAvananExceptionsDao.blacklistCreate(makeFilters());
                }
                createAPI.then(function () {
                    $modalInstance.close();
                    if (options.afterLoadFn && _(options.afterLoadFn).isFunction()) {
                        options.afterLoadFn();
                    }
                }, function (error) {
                    if (error.status >= 400 && error.status < 500 && error.data && error.data.message) {
                        $scope.error = error.data.message;
                    } else {
                        $scope.error = 'Error creating ' + keyword + ' rule';
                    }
                    $scope.loading = false;
                    if (options.afterLoadFn && _(options.afterLoadFn).isFunction()) {
                        options.afterLoadFn();
                    }
                });
            });
        };
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        var standardColumns = [
            {
                id: 'entity_id',
                hidden: true
            },
            {
                id: 'entity_type',
                hidden: true
            },
            {
                id: 'received_at',
                text: 'Received',
                format: 'time'
            },
            {
                id: 'recipients',
                text: 'Recipients',
                converter: 'listConverter',
                converterArgs: {
                    elementAsTooltip: true,
                    moreInPopup: true,
                    expanded: 10,
                    collapseRest: true,
                    countPostfix: 'recipients'
                }
            }
        ];
        $scope.options = {
            columns: [],
            options: {
                defaultOrdering: {
                    columnName: 'time',
                    order: 'desc'
                },
                checkboxes: false
            }
        };
        $scope.tableOptions = {
            disableTop: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            reloadUuid: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            pagesAround: 2,
            pagination: {
                pageSize: 20,
                ordering: {}
            },
            dropdownHeader: true
        };
        function genVariant(str, arr) {
            if (str.indexOf('.') !== -1) {
                var subStr = str.slice(str.indexOf('.') + 1);
                if (subStr.indexOf('.') !== -1) {
                    arr.push({
                        id: '.' + subStr,
                        label: '@*.' + subStr
                    });
                    genVariant(subStr, arr);
                }
            }
        }
        function genColumns(data, index) {
            var ipValidationTip = 'A valid IP can be in <strong>IPv4</strong> or <strong>IPv6</strong> format. <strong>IPv4</strong> contains ' + 'four numbers (0-255) separated by periods (ex: 1.2.3.4). You may also specify a subnet (ex: 1.2.3.4/32). ' + '<strong>IPv6</strong> contains eight groups of four hexadecimal digits, each group representing 16 bits ' + '(ex:2001:0db8:85a3:0000:0000:8a2e:0370:7334)';
            var newParams = _(data).chain().map(function (val, key) {
                var newParam = {
                    id: key,
                    label: val.label,
                    order: val.order
                };
                if (val.noCheckbox) {
                    newParam.noCheckbox = val.noCheckbox;
                }
                if (val.hidden) {
                    newParam.hidden = val.hidden;
                }
                if (val.showOtherParam) {
                    newParam.showOtherParam = val.showOtherParam;
                }
                if (options.type === 'whitelist') {
                    if (key === 'ips') {
                        _.extend(newParam, {
                            data: val.value ? [val.value] : [],
                            type: 'list',
                            enabled: true,
                            settings: {
                                errTipContent: 'Not valid IP',
                                parentElement: '.form-inline',
                                successTipContent: 'Valid IP',
                                validation: true,
                                validationType: 'ip',
                                validationOnTyping: true
                            },
                            tooltip: ipValidationTip
                        });
                    } else if (key === 'domains') {
                        _.extend(newParam, {
                            data: val.value ? [val.value] : [],
                            type: 'list',
                            enabled: true,
                            settings: {
                                errTipContent: 'Not valid Domain',
                                parentElement: '.form-inline',
                                successTipContent: 'Valid Domain',
                                validation: true,
                                validationType: 'domain',
                                validationOnTyping: true
                            }
                        });
                    } else if (key === 'user_label') {
                        _.extend(newParam, {
                            variants: val.variants,
                            type: 'selector',
                            enabled: true
                        });
                    } else {
                        _.extend(newParam, {
                            data: val.type === 'string' ? val.value : val.value ? [val.value] : [],
                            type: val.type === 'string' ? 'string' : 'list',
                            enabled: val.enabled === undefined ? true : val.enabled
                        });
                    }
                } else {
                    if (key === 'sender_domain_suffix' && val.value) {
                        var variants = [{
                                id: val.value,
                                label: '@' + val.value
                            }];
                        genVariant(val.value, variants);
                        _.extend(newParam, {
                            variants: variants,
                            type: 'selector',
                            enabled: false
                        });
                    } else if (key === 'subject_matching') {
                        _.extend(newParam, {
                            data: val.data,
                            type: 'radio-group',
                            enabled: true,
                            buttons: val.buttons
                        });
                    } else if (key === 'sender_ip' || key === 'sender_client_ip') {
                        _.extend(newParam, {
                            data: val.value,
                            type: 'string',
                            enabled: true,
                            settings: {
                                errTipContent: 'Not valid IP',
                                parentElement: '.param-control',
                                successTipContent: 'Valid IP',
                                validation: true,
                                validationType: 'ip'
                            },
                            tooltip: ipValidationTip
                        });
                    } else if (key === 'user_label') {
                        _.extend(newParam, {
                            variants: val.variants,
                            type: 'selector',
                            enabled: true
                        });
                    } else {
                        _.extend(newParam, {
                            data: val.value,
                            type: 'string',
                            enabled: val.enabled === undefined ? true : val.enabled
                        });
                    }
                    if (key === 'with_links_to_domains') {
                        _.extend(newParam, { advanced: true });
                    }
                }
                return newParam;
            }).sortBy('order').value();
            if (!index) {
                $scope.params = newParams;
            } else {
                $scope['params' + index.toString()] = newParams;
                return;
            }
            var additionalColumns = [];
            if (options.type === 'whitelist') {
                additionalColumns = [
                    {
                        id: 'sender_ip',
                        text: 'Sender IP (SMTP)',
                        converter: simpleTooltipConverter
                    },
                    {
                        id: 'sender_address',
                        text: 'Sender Email',
                        converter: simpleTooltipConverter
                    },
                    {
                        id: 'nickname',
                        text: 'Sender Name',
                        converter: simpleTooltipConverter
                    }
                ];
            } else {
                var nonColumns = {
                    'sender_domain_suffix': true,
                    'subject_matching': true
                };
                additionalColumns = _(newParams).chain().reject(function (param) {
                    return nonColumns[param.id];
                }).map(function (param) {
                    if (param.id === 'subject') {
                        return {
                            id: param.id,
                            text: param.label,
                            converter: 'profileLinkConverter'
                        };
                    }
                    return {
                        id: param.id,
                        text: param.label,
                        converter: simpleTooltipConverter
                    };
                }).value();
            }
            return additionalColumns;
        }
        if (options.entityType && options.entityId) {
            $scope.title = options.title || 'Mark emails as ' + keyword;
            $scope.titleExplanation = 'The selected emails as well as any future emails that meet all of the criteria below will be handled as ' + keyword + '-emails';
            var p;
            if (feature.enableAPWhitelistReason && options.type === 'whitelist') {
                var queries = [
                    apAvananExceptionsDao.whitelistOptions(options.entityType, options.entityId),
                    apAvananExceptionsDao.exceptionComboOptions({
                        debug_level: troubleshooting.entityDebugEnabled() ? 1 : 0,
                        combo_name: 'whitelist',
                        entity_type: options.entityType,
                        entity_id: options.entityId
                    })
                ];
                p = $q.allSettled(queries);
            } else {
                if (options.type === 'whitelist') {
                    p = apAvananExceptionsDao.whitelistOptions(options.entityType, options.entityId);
                } else {
                    p = apAvananExceptionsDao.blacklistOptions(options.entityType, options.entityId);
                }
            }
            p.then(function (responses) {
                var respData = {};
                if (feature.enableAPWhitelistReason && options.type === 'whitelist' && responses[1].value && responses[1].value.data) {
                    respData = responses[0].value.data;
                    if (!_(responses[1].value.data).isEmpty()) {
                        genColumns({
                            user_label: {
                                label: responses[1].value.data.name,
                                order: 10,
                                value: responses[1].value.data.default,
                                variants: _(responses[1].value.data.options).map(function (val, key) {
                                    return {
                                        id: val.id,
                                        label: val.text
                                    };
                                }),
                                showOtherParam: {
                                    paramId: 'comment',
                                    data: 'other'
                                },
                                noCheckbox: true
                            },
                            comment: {
                                label: 'Other - Description',
                                order: 11,
                                type: 'string',
                                enabled: false,
                                hidden: true,
                                noCheckbox: true
                            }
                        }, 1);
                    }
                } else if (!feature.enableAPWhitelistReason || options.type !== 'whitelist') {
                    respData = responses.data;
                }
                $scope.options.columns = standardColumns.concat(genColumns(respData));
                $scope.loading = false;
                $scope.loaded = true;
            }, function (error) {
                $scope.loading = false;
                $scope.error = 'This email can not be Block-Listed';
            });
        } else if (options.blacklistId) {
            $scope.mode = 'rule';
            $scope.title = 'Block-List Item';
            apAvananExceptionsDao.blacklistItem(options.blacklistId).then(function (response) {
                if (!response.data.labels) {
                    return;
                }
                $scope.params = _(response.data.blacklist).chain().map(function (val, key) {
                    if (_(val).isNull() || !response.data.labels[key]) {
                        return;
                    }
                    return {
                        id: key,
                        label: response.data.labels[key].label,
                        data: val,
                        type: 'string',
                        order: response.data.labels[key].order,
                        enabled: false
                    };
                }).compact().sortBy('order').value();
                $scope.options.columns = standardColumns.concat(_(response.data.labels).chain().map(function (val, key) {
                    return {
                        id: key,
                        text: val.label,
                        converter: simpleTooltipConverter
                    };
                }).sortBy('order').value());
                $scope.loading = false;
                $scope.loaded = true;
                $timeout(initTable);
            }, function (error) {
                $scope.loading = false;
                $scope.error = 'Item not found';
            });
        } else if (options.isNew) {
            $scope.options.columns = standardColumns.concat(genColumns({
                subject: {
                    label: 'Subject',
                    order: 1
                },
                subject_matching: {
                    label: 'Subject Matching',
                    value: 'exact',
                    type: 'radio-group',
                    order: 2,
                    enabled: true,
                    buttons: [
                        {
                            value: 'exact',
                            label: 'Exact match'
                        },
                        {
                            value: 'contains',
                            label: 'Substring match'
                        }
                    ]
                },
                sender_ip: {
                    label: 'Sender IP (SMTP)',
                    order: 3
                },
                sender_client_ip: {
                    label: 'Sender IP (Client)',
                    order: 4
                },
                sender_address: {
                    label: 'Sender Email',
                    order: 5
                },
                nickname: {
                    label: 'Sender Name',
                    order: 6
                },
                sender_domain_suffix: {
                    label: 'Sender Domain suffix',
                    order: 7
                }
            }));
            $scope.loading = false;
            $scope.loaded = true;
        }
        var queryFilters = null;
        var refreshDelay = null;
        /*
    * @param additionalParams is an array of params arrays.
    * example: [$scope.params1, $scope.params2]
    *
    * */
        function makeFilters(additionalParams) {
            var newData = _($scope.params).chain().map(function (param) {
                if (param.enabled && param.data) {
                    return [
                        param.id,
                        param.data
                    ];
                }
            }).compact().object().value();
            if (options.type === 'whitelist' && options.entityType && options.entityId) {
                newData.entity_id = options.entityId;
                newData.entity_type = options.entityType;
            }
            if (options.scanStatus === 'clean' && _(newData).isObject()) {
                newData.status = 'phishing';
                newData.confident = 'medium';
            } else if ((options.scanStatus === 'suspicious' || options.scanStatus === 'phishing') && _(newData).isObject()) {
                newData.status = 'clean';
                newData.confident = 'medium';
            }
            if (additionalParams && additionalParams.length) {
                _(additionalParams).each(function (params) {
                    _(params).each(function (param) {
                        if (param.enabled && param.data) {
                            newData[param.id] = param.data;
                        }
                    });
                });
            }
            return newData;
        }
        function refreshTable() {
            if ($scope.tableHelper) {
                $scope.tableHelper.reload();
            } else {
                initTable();
            }
        }
        function scheduleFiltersRefresh() {
            if ($scope.mode === 'rule') {
                return;
            }
            var filters = makeFilters();
            if (filters.with_links_to_domains) {
                $scope.withLinksToDomainsWarning = true;
                return;
            } else {
                $scope.withLinksToDomainsWarning = false;
            }
            if (refreshDelay) {
                $timeout.cancel(refreshDelay);
                refreshDelay = null;
            }
            if (!$scope.loaded) {
                return;
            }
            if (!angular.equals(filters, queryFilters)) {
                refreshDelay = $timeout(refreshTable, 400);
            }
        }
        $scope.okLabel = function () {
            if ($scope.error || $scope.mode === 'rule') {
                return '';
            }
            if (!$scope.tableModel || $scope.tableOptions.loading) {
                return 'Create ' + keyword + ' rule';
            }
            if ($scope.totalEmails) {
                $scope.okTip = 'Mark matching emails (as well as future once) as ' + keyword;
                if (options.type === 'whitelist') {
                    return 'Create exception';
                }
                return 'Create Block-List rule';
            }
            return 'Create ' + keyword + ' rule that does\'t match any existing email';
        };
        $scope.$watch('params', function (newValue, oldValue) {
            var notValid = false;
            var noParams = 0;
            _(newValue).each(function (param) {
                param.readOnly = !param.enabled;
                if ((param.id === 'sender_ip' || param.id === 'sender_client_ip') && param.settings && param.settings.validation && param.data && !regexUtility.utilities.validationIPandSubnet(param.data)) {
                    notValid = true;
                }
                if (param.showOtherParam) {
                    var eventName = param.showOtherParam.data === param.data ? 'show-param' : 'hide-param';
                    $scope.$emit(eventName, {
                        id: param.showOtherParam.paramId,
                        params: 'params'
                    });
                }
                if (!param.enabled || !param.data) {
                    noParams++;
                }
            });
            if ($scope.tableOptions && (notValid || noParams === (newValue && newValue.length)) && !options.blacklistId) {
                if (notValid) {
                    $scope.notAllowed = 'Not valid input field. Please correct.';
                } else if (noParams === $scope.params.length) {
                    $scope.notAllowed = 'All params are empty. Please fill out one at least.';
                }
                $scope.tableOptions.loading = true;
            } else {
                $scope.notAllowed = '';
                scheduleFiltersRefresh();
            }
        }, true);
        $scope.$watch('params1', function (newValue, oldValue) {
            _(newValue).each(function (param) {
                if (param.showOtherParam) {
                    var eventName = param.showOtherParam.data === param.data ? 'show-param' : 'hide-param';
                    $scope.$emit(eventName, {
                        id: param.showOtherParam.paramId,
                        params: 'params1'
                    });
                }
            });
        }, true);
        $scope.$on('show-param', function (event, data) {
            _($scope[data.params]).find(function (param) {
                if (param.id === data.id && param.hidden) {
                    param.hidden = false;
                    param.enabled = true;
                    return true;
                }
                return false;
            });
        });
        $scope.$on('hide-param', function (event, data) {
            _($scope[data.params]).find(function (param) {
                if (param.id === data.id && !param.hidden) {
                    param.hidden = true;
                    param.enabled = false;
                    return true;
                }
                return false;
            });
        });
        function initTable() {
            $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                queryFilters = makeFilters();
                var q;
                if ($scope.mode === 'rule') {
                    q = apAvananExceptionsDao.blacklistItem(options.blacklistId);
                } else {
                    if (options.type === 'whitelist') {
                        q = apAvananExceptionsDao.whitelistMatching(queryFilters);
                    } else {
                        q = apAvananExceptionsDao.blacklistMatching(queryFilters);
                    }
                }
                $scope.error = '';
                return q.pagination(args.offset, args.limit).converter(defaultListConverter, { columns: $scope.options.columns }).onRequestFail(function (error) {
                    if (error.status === 400 && error.data && error.data.message) {
                        $scope.error = error.data.message;
                        return $q.when({
                            data: {
                                rows: [],
                                total_rows: 0
                            }
                        });
                    } else {
                        return $q.reject(error);
                    }
                });
            }, function (tableModel) {
                $scope.tableModel = tableModel;
                $scope.totalEmails = $scope.tableHelper.getTotal();
            });
        }
    }]);
    m.factory('apExceptionsModal', ["$modal", "path", "feature", "$rootScope", function ($modal, path, feature, $rootScope) {
        return {
            show: function (options) {
                if (feature.mailExplorer2) {
                    var templateUrl = path('advanced-data-search').ctrl('mail-explorer-new').template();
                    var instance = $modal.open({
                        templateUrl: templateUrl,
                        size: 'lg',
                        controller: 'MailExplorerNew',
                        windowClass: 'mail-explorer-modal',
                        resolve: { options: _.constant(options) }
                    });
                    $rootScope.closeMailExplorerModal = function () {
                        instance.close();
                    };
                    return instance.result;
                } else {
                    var modalInstance = $modal.open({
                        templateUrl: path('gui-v2').ctrl('ap-exceptions-modal').template(),
                        controller: 'ApExceptionsModalController',
                        size: 'lg',
                        backdrop: _(options).isObject() && !_(options.backdrop).isUndefined() ? options.backdrop : true,
                        keyboard: _(options).isObject() && !_(options.keyboard).isUndefined() ? options.keyboard : true,
                        resolve: { options: _.constant(options) },
                        windowClass: 'ap-avanan-add-blacklist-modal-window'
                    });
                    return modalInstance.result;
                }
            }
        };
    }]);
}());